import React, { useState, useEffect } from "react";
import theme from "../../theme/theme";
import ResultDetailModal from "./ResultDetailModal";
import { Api } from "../../network/api";

const Results = () => {
  const [selectedResult, setSelectedResult] = useState(null);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedResultData, setSelectedResultData] = useState(null);
  const [loadingResultData, setLoadingResultData] = useState(false);

  const getStatusStyle = (status) => {
    switch (status) {
      case "approved":
        return { backgroundColor: "#dcfce7", color: "#166534" };
      case "processing":
        return {
          backgroundColor: theme.Colors.primary,
          color: theme.Colors.textSecondary,
        };
      case "failed":
        return { backgroundColor: "#fee2e2", color: "#991b1b" };
      default:
        return { backgroundColor: "#f3f4f6", color: "#374151" };
    }
  };

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    try {
      setLoading(true);
      const response = await Api.getSubmissions();
      console.log("response", response);
      setResults(response.data);
    } catch (error) {
      console.error("Error loading results:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDetails = async (result) => {
    try {
      setLoadingResultData(true);
      setSelectedResult(result);

      const response = await Api.getResultDetails(result.id);
      setSelectedResultData(response);
      setLoadingResultData(false);
    } catch (error) {
      console.error("Error loading result details:", error);
      setLoadingResultData(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">Analysis Results</h1>
          <p className="text-gray-600 mt-1">
            View and manage your essay analysis results
          </p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Assignment Name
                </th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Submission Date
                </th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="4" className="px-6 py-8 text-center">
                    <div className="flex items-center justify-center">
                      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
                      <span className="ml-2 text-gray-600">
                        Loading results...
                      </span>
                    </div>
                  </td>
                </tr>
              ) : (
                results.map((result) => (
                  <tr
                    key={result.id}
                    className="hover:bg-gray-50 transition-colors duration-200"
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">
                        {result.subject_name}
                      </div>
                      <div className="text-sm text-gray-500">
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {new Date(result.submit_date).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                        style={getStatusStyle(result.status)}
                      >
                        {result.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {result.status === "approved" && (
                        <button
                          onClick={() => handleOpenDetails(result)}
                          className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white transition-colors duration-200 hover:opacity-80"
                          style={{ backgroundColor: theme.Colors.primary }}
                        >
                          Open
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {!loading && results.length === 0 && (
          <div className="text-center py-12">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              No results yet
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Upload your first essay to see analysis results here.
            </p>
          </div>
        )}
      </div>
      {selectedResult && (
        <ResultDetailModal
          result={selectedResult}
          onClose={() => {
            setSelectedResult(null);
            setSelectedResultData(null);
          }}
          aiResponseData={selectedResultData}
          loading={loadingResultData}
        />
      )}
    </div>
  );
};

export default Results;